var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"black"}},[_vm._v("password")])
}
var staticRenderFns = []

export { render, staticRenderFns }